module.exports = __webpack_public_path__ + "static/media/branno.b20f03ab.jpeg";